<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="logisticSelected"
    :clearable="!unclearable"
    :items="logisticsItems"
    :loading="logisticLoading"
    :search-input.sync="logisticSearch"
    item-text="Description"
    item-value="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('Stock.ObjectName')"
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
    :disabled="disabled"
    return-object
  ></v-autocomplete>
</template>

<script>
import Logistics from "@/api/logistics";

export default {
  name: "SearcherLogistic",

  props: {
    value: Object,
    noLabel: Boolean,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
    disabled: Boolean,
  },

  computed: {
    logisticsItems() {
      return this.logistics.map((logistic) => {
        const Description = logistic.Description
          ? logistic.Description
          : logistic.logistics_name + " - " + logistic.linkman;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == logistic.id
            )
          : false;
        return Object.assign({}, logistic, { Description, disabled });
      });
    },
  },

  data: () => ({
    logistics: [],
    logisticLoading: false,
    logisticSearch: "",
    logisticSelected: null,
  }),

  mounted() {
    this.logisticLoading = true;
    Logistics.fetchAll({})
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.logistics = response.data.logistics.filter(
              (item) => item.delete_flg == false
            );
          }
          this.logisticLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.logisticLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.logisticSelected = this.value;
      },
    },
    logisticSelected: {
      handler() {
        this.$emit("input", this.logisticSelected);
      },
    },
  },
};
</script>